import { api } from '@setplex/tria-api'

export const $isBannersLoading = api.banners.getBannersFx.pending
